import { useEffect, useState } from 'react';
import { getCoursesAdmin } from '../api/courses';
import { useAuth } from '../context/AuthContext';

import { scopeCoursesToUser } from '../utils/scope';

/**
 * Returns the set of course IDs the current user works with.
 * Non-admin staff are scoped to the courses they own (createdById) so each
 * B2B client only sees data tied to their courses. Account admins see the
 * whole catalogue — /courses/admin is already tenant-scoped by the backend,
 * so an admin no longer lands on an "empty CRM" when courses were created
 * by teachers or other staff.
 */
export default function useMyCourseIds() {
  const { user } = useAuth();
  const [ids, setIds] = useState(null);
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!user?.id) return;
    setError(null);
    getCoursesAdmin({ limit: 100, page: 1 })
      .then((res) => {
        if (cancelled) return;
        const mine = scopeCoursesToUser(res?.data || [], user);
        setCourses(mine);
        setIds(new Set(mine.map((c) => c.id)));
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setIds(new Set());
      });
    return () => { cancelled = true; };
  }, [user]);

  return { courseIds: ids, courses, loading: ids === null, error };
}
